import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c7a2b7de"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "zaixiantongji",
  style: {
    "padding": "0 5px"
  }
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "在线统计")], -1));

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  class: "panel",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_6 = {
  class: "panel-title"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("刷新");

const _hoisted_8 = {
  class: "panel-body"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "panel",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_11 = {
  class: "panel-title"
};
const _hoisted_12 = {
  style: {
    "float": "right"
  }
};
const _hoisted_13 = {
  style: {
    "margin": "0 20px"
  }
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总计：", -1));

const _hoisted_15 = {
  style: {
    "color": "red"
  }
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  注额：", -1));

const _hoisted_17 = {
  style: {
    "color": "red"
  }
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode("返 回");

const _hoisted_19 = {
  class: "panel-body"
};
const _hoisted_20 = {
  style: {
    "color": "red"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
    data: $data.group_count,
    border: "",
    size: "mini",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [_ctx.$store.state.userinfo.group_id < 2 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      align: "center",
      label: "大总监"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => $options.get_sub_users('在线大总监', 2))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.dzj), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 1,
      align: "center",
      label: "总监"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => $options.get_sub_users('在线总监', 3))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.zj), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 4 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 2,
      align: "center",
      label: "分公司"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = $event => $options.get_sub_users('在线分公司', 4))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.fgs), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 5 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 3,
      align: "center",
      label: "大股东"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => $options.get_sub_users('在线大股东', 5))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.dgd), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 6 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 4,
      align: "center",
      label: "股东"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => $options.get_sub_users('在线股东', 6))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.gd), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 7 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 5,
      align: "center",
      label: "总代理"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => $options.get_sub_users('在线总代理', 7))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.zdl), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 8 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 6,
      align: "center",
      label: "代理"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[6] || (_cache[6] = $event => $options.get_sub_users('在线代理', 8))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.dl), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      align: "center",
      label: "会员"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[7] || (_cache[7] = $event => $options.get_sub_users('在线会员', 0))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.hy), 1)]),
        _: 2
      }, 1024)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"])])]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h2", null, [_createElementVNode("span", null, _toDisplayString($data.typename) + "：电脑" + _toDisplayString($data.pc_num) + "人，手机：" + _toDisplayString($data.phone_num) + "人", 1)]), _createVNode(_component_el_button, {
    style: {
      "float": "right",
      "margin-top": "3px"
    },
    type: "primary",
    size: "small",
    onClick: $options.ref_list
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_table, {
    data: $data.list,
    border: "",
    size: "mini",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      property: "id",
      label: "编号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "username",
      label: "账号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "real_name",
      label: "姓名",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "platform",
      label: "登录设备",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "diff_time",
      label: "在线时长",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "posttime",
      label: "最后操作时间",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "ip",
      label: "IP",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "ip_address",
      label: "IP地址",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "count",
      label: "未结算注单",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_link, {
        type: "primary",
        onClick: $event => $options.get_weijie(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.count), 1)]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "",
      label: "操作",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", {
        class: "tichu",
        onClick: $event => $options.tichu(scope.row)
      }, "踢出系统", 8, _hoisted_9)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_pagination, {
    class: "paging",
    small: "",
    "current-page": $data.page,
    "onUpdate:current-page": _cache[8] || (_cache[8] = $event => $data.page = $event),
    "page-size": 20,
    "pager-count": 5,
    total: $data.pagination.total_records * 1,
    "page-count": $data.pagination.total_pages * 1,
    layout: "total,prev,pager,next,jumper",
    "prev-text": "上一页",
    "next-text": "下一页",
    "hide-on-single-page": ""
  }, null, 8, ["current-page", "total", "page-count"])])], 512), [[_vShow, !$data.weijie.show]]), _withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("h2", null, [_createElementVNode("span", null, "未结算注单：" + _toDisplayString($data.weijie.username), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, [_hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString($data.weijie.total.count) + "单", 1), _hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString($data.weijie.total.balance), 1)]), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: _cache[9] || (_cache[9] = $event => $data.weijie.show = false)
  }, {
    default: _withCtx(() => [_hoisted_18]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_table, {
    data: $data.weijie.list,
    border: "",
    size: "mini",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      property: "game_name",
      label: "彩种",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "qnum",
      label: "期号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "order_id",
      label: "注单号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "platform",
      label: "下注时间",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.$filters.time(scope.row.posttime, '报表注单')), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "game_level",
      label: "下注明细",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.game_level) + "@", 1), _createElementVNode("span", _hoisted_20, _toDisplayString(scope.row.list_bonus * 1), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "balance",
      label: "下注额",
      align: "center"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_pagination, {
    class: "paging",
    small: "",
    modelValue: $data.weijie.page,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.weijie.page = $event),
    onCurrentChange: _cache[11] || (_cache[11] = $event => $options.get_weijie($data.weijie.row, $event)),
    "default-page-size": $data.weijie.limit,
    "pager-count": 5,
    total: $data.weijie.pagination.total_records * 1,
    layout: "total,prev,pager,next,jumper",
    "prev-text": "上一页",
    "next-text": "下一页",
    "hide-on-single-page": ""
  }, null, 8, ["modelValue", "default-page-size", "total"])])], 512), [[_vShow, $data.weijie.show]])]);
}